// extracted by mini-css-extract-plugin
export default {"button":"SelectButton-module__button___M8eCZ","button-before":"SelectButton-module__button-before___g4riA","angle":"SelectButton-module__angle___eZEgc"};